import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import * as React from 'react';
import { EmailEvent } from '../../../../types/EmailDatum';
import { humanizeTimestamp } from '../../../../utility/dateUtils';

interface IEmailEventsPopoverProps {
  emailEvents: EmailEvent[];
}

export default function EmailEventsPopover({ emailEvents }: IEmailEventsPopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'events-popover' : undefined;

  if (emailEvents.length === 0) return 'N/A';

  const renderEvent = (emailEvent: EmailEvent) => (<Typography>{_.join([emailEvent.action, humanizeTimestamp(emailEvent.created_at)], ' - ')}</Typography>);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="body2">{renderEvent(emailEvents[0])}</Typography>
      {emailEvents.length > 1 && (
        <>
          <IconButton onClick={handleClick} size="small">
            <MoreHorizIcon />
          </IconButton>
          <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
            <Box sx={{ p: 2 }}>
              {_.map(_.slice(emailEvents, 1), (emailEvent, index) => (
                <Typography key={index} variant="body2">
                  {renderEvent(emailEvent)}
                </Typography>
              ))}
            </Box>
          </Popover>
        </>
      )}
    </Box>
  );
}
